import { useState } from "react";
import { Plus } from "lucide-react";
import { observer } from "mobx-react-lite";
import AddCanvasModal from "./AddCanvasModal";

const ADD_CANVAS_LABEL = "Add new canvas";

interface CanvasTypeSelectorProps {
  notebookId: number | null;
}

function CanvasTypeSelectorInner({ notebookId }: CanvasTypeSelectorProps) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="flex flex-1 flex-col items-center justify-center bg-white gap-y-8">
      <button
        type="button"
        onClick={() => setModalOpen(true)}
        className="inline-flex items-center gap-2 rounded-xl border-2 border-[#6AF931] bg-[#1A1A1A] px-8 py-4 text-[16px] font-semibold text-white transition hover:bg-[#2d2d2d]"
      >
        <Plus size={22} strokeWidth={2.5} />
        {ADD_CANVAS_LABEL}
      </button>
      <AddCanvasModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        notebookId={notebookId}
      />
    </div>
  );
}

export default observer(CanvasTypeSelectorInner);
